/**
 * API Endpoint Constants
 * Centralized definition of all API endpoints
 *
 * Note: These paths are relative to the baseURL configured in the API client.
 * The /api prefix is part of the baseURL, not the endpoint paths.
 *
 * BRP-671: tenants and their nested licenses live under the Management API
 * namespace (/api/management/tenants/...). The package catalog endpoint stays
 * under /api/tenants/ — it pre-dates the management split.
 */

export const API_ENDPOINTS = {
  // Tenant endpoints (Management API)
  TENANTS: '/management/tenants/',
  TENANT_DETAIL: (id: string) => `/management/tenants/${id}/`,

  // License endpoints (Management API, nested under tenants)
  TENANT_LICENSES: (tenantId: string) => `/management/tenants/${tenantId}/licenses/`,
  LICENSE_DETAIL: (tenantId: string, licenseId: string) => `/management/tenants/${tenantId}/licenses/${licenseId}/`,

  // License package catalog (not part of Management API)
  LICENSE_PACKAGES: '/tenants/packages/',

  // Management dashboard overview
  TENANT_OVERVIEW: '/management/tenants/overview/',
  TENANT_OVERVIEW_DETAILS: '/management/tenants/overview/details/',
} as const
